import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <h6 className="fsz-18 text-uppercase lh-4">
              what clients say <br /> about us
            </h6>
            <div className="lg-icon color-orange1">
              <i className="la la-quote-right"></i>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tc-clients-style1">
              <div className="clients-slider1">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-45 fw-600 lh-2 js-splittext-lines">
                        “Working with SS Architects & Interiors was a seamless experience. They understood our vision perfectly and transformed it into a beautiful, functional home. Every detail was thoughtfully planned, and the final outcome exceeded our expectations.”
                      </div>
                      <div className="author">
                        
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                            Tanveer Singh
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Property Owner
                          </p>
                        </div>  
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-45 fw-600 lh-2 js-splittext-lines">
                        “The team was highly professional, creative, and attentive throughout the project. Their expertise in space planning and interior design helped us achieve a modern home that is both elegant and practical. We couldn't be happier with the results.”
                      </div>
                      <div className="author">
                        
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                            Harvinder Singh
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                            Entrepreneur
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="clients-card">
                      <div className="text fsz-45 fw-600 lh-2 js-splittext-lines">
                        “From the initial consultation to project completion, SS Architects & Interiors maintained exceptional quality and communication. Their attention to detail and commitment to delivering timeless designs truly set them apart. Highly recommended.”
                      </div>
                      <div className="author">
                       
                        <div className="au-inf">
                          <h6 className="text-capitalize mb-2 fsz-16 fw-bold">
                           Mandeep Kaur
                          </h6>
                          <p className="text-capitalize fsz-14 color-666">
                             Interior Design Client
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="slider-controls">
                  <div className="swiper-button-prev"></div>
                  <div className="swiper-pagination"></div>
                  <div className="swiper-button-next"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <a href="#"> Creative </a>
          </div>
          <div className="swiper-slide">
            <a href="#"> Flexiable </a>
          </div>
          <div className="swiper-slide">
            <a href="#"> Dedicated </a>
          </div>
        </div>
      </div>
      <img src="/innerpages/assets/img/c_line3.png" alt="" className="c-line" />
    </section>
  );
}

export default Testimonials;
